module.exports = __webpack_public_path__ + "img/second.92781255.png";